import React, { useEffect, useState } from "react"
import { FormField, Text, Button, SelectMenu, Pane, Link } from "evergreen-ui"
import * as R from "ramda"
import asset1 from "./assets/example1.png"

const handleChange = (onChange, thumb) => {
  let img = new Image()
  img.onload = function() {
    onChange({
      thumb: this.src,
      width: this.width,
      height: this.height,
    })
  }
  img.src = thumb
}

const Item = ({ thumb, label, onChange, backgroundColor }) => {
  const [size, setSize] = useState({})
  useEffect(() => {
    // Update the document title using the browser API
    // document.title = `You clicked ${count} times`;
    let img = new Image()
    img.onload = function() {
      setSize({ width: this.width, height: this.height })
    }
    img.src = thumb
  }, [])
  return (
    <Pane
      display="flex"
      alignItems="center"
      padding={5}
      border
      cursor="pointer"
      onClick={() => {
        handleChange(onChange, thumb)
      }}
    >
      <Pane
        border
        width={(40 * size.width) / size.height}
        height={40}
        backgroundImage={`url(${thumb})`}
        backgroundRepeat="no-repeat"
        backgroundSize="contain"
        backgroundColor={backgroundColor}
        backgroundPosition="center"
        marginRight={10}
      />
      <Text size={300}>{label}</Text>
    </Pane>
  )
}

class FileInput extends React.Component {
  triggerInputFile = () => this.fileInput.click()

  render() {
    return (
      <Pane>
        <Pane display="none">
          <input
            ref={fileInput => (this.fileInput = fileInput)}
            type="file"
            onChange={e => {
              const { onChange } = this.props
              const files = e.target.files
              if (files && files[0]) {
                let reader = new FileReader()
                reader.onloadend = () => {
                  let img = new Image()
                  img.onload = function() {
                    onChange({
                      thumb: this.src,
                      width: this.width,
                      height: this.height,
                    })
                  }
                  img.src = reader.result
                }

                reader.readAsDataURL(files[0])
              }
            }}
          />
        </Pane>
        <Button
          iconBefore="upload"
          width="100%"
          onClick={this.triggerInputFile}
          textAlign="center"
        >
          Upload
        </Button>
      </Pane>
    )
  }
}

export default function({
  label,
  description,
  value,
  validationMessage,
  onChange,
  options,
  backgroundColor,
}) {
  return (
    <FormField
      label={label}
      validationMessage={validationMessage}
      description={
        <Text size={300} display="block" marginBottom={5}>
          {description}
        </Text>
      }
      marginBottom={10}
    >
      <Pane display="flex" alignItems="center">
        <SelectMenu
          title="Upload or select a file"
          options={[]}
          emptyView={
            <Pane
              height="100%"
              overflow="auto"
              display="flex"
              flexDirection="column"
            >
              <FileInput onChange={onChange} />
              {options &&
                R.map(({ thumb, label }) => (
                  <Item
                    key={thumb}
                    thumb={thumb}
                    label={label}
                    onChange={onChange}
                    backgroundColor={backgroundColor}
                  />
                ))(options)}
            </Pane>
          }
        >
          <Pane display="flex">
            <Button>Select file</Button>
            {value && value.thumb && (
              <Pane
                display="flex"
                alignItems="Center"
                marginLeft={5}
                marginRight={5}
              >
                <Pane
                  border
                  width={(30 * value.width) / value.height}
                  height={30}
                  backgroundImage={`url(${value.thumb})`}
                  backgroundRepeat="no-repeat"
                  backgroundSize="contain"
                  backgroundColor={backgroundColor}
                  marginRight={10}
                  backgroundPosition="center"
                />
                <Text size={300}>
                  {value.width}x{value.height}px
                </Text>
              </Pane>
            )}
          </Pane>
        </SelectMenu>
      </Pane>
      {value && value.thumb && (
        <Link
          size={300}
          cursor="pointer"
          onClick={() => {
            onChange({})
          }}
        >
          Remove
        </Link>
      )}
    </FormField>
  )
}
